import React from 'react';

function WhyItMatters() {
  return (
    <section className="story">
      <div className="container">
        <h2>Why This Matters Now</h2>
        <div className="story-content">
          <p>
            When TMT Sir was teaching, the world was simpler in one crucial way: what you learned in school 
            stayed relevant for years. Memorize the formula, apply the formula, move on. Success meant knowing things.
          </p>

          <p>
            That world is gone.
          </p>

          <p>
            AI is rewriting what knowledge means. Every domain is shifting. What matters now is not what you know
            but what you can figure out. Not memorization, but reasoning. Not answers, but the right questions.
          </p>

          <p>
            This isn't theoretical. Indian employers report a stark reality: fresh college graduates arrive with
            credentials but without deployable skills. They need to be trained from scratch. In a world where information
            is free, the ability to learn independently, to engage with new ideas, reason through them, adapt, has
            become the primary competitive advantage.
          </p>

          <p>
            Even in India's ultra-competitive traditional high schools, students drowning in content need something
            different: the ability to filter signal from noise, to understand what actually matters, to think clearly
            rather than just accumulate facts.
          </p>

          <p>
            Here's the bold claim: Learning fluency is THE skill. Domain content matters, physics, commerce,
            languages, but the process of learning, reasoning, and adapting is universal. Teach students what to
            think, and they're dependent on what they've memorized. Teach them how to think, and they can learn
            anything.
          </p>

          <p>
            That's why we're building the Learning Center. Not as a tribute to one teacher, but as proof that
            learning fluency can be effectively taught, measured, and scaled. In a world that changes faster
            than any curriculum can keep up, it's the only skill that will matter.
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhyItMatters;